module.exports = __webpack_public_path__ + "img/community.f1ee3df1.png";